import { Controller } from "@hotwired/stimulus"

// Adds 'visible' class to targets when they enter the viewport for fade-in animation
export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("viewport-visible")
          }
        })
      },
      { rootMargin: "0px 0px -40px 0px", threshold: 0.1 }
    )
    this.itemTargets.forEach((el) => this.observer.observe(el))
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
